import React from 'react'
import './contact.scss'
import { Formik, Field } from 'formik'
import * as yup from 'yup'
import ContactForm from '../forms/ContactForm'

function Contact() {
   const schema = yup.object({
      name: yup.string().required('name is required'),
      email: yup
         .string()
         .email('valid email required')
         .required('email is required'),
      message: yup.string(),
   })
   const initvalues = {
      name: '',
      email: '',
      message: ' ',
   }
   return (
      <div className="contact">
         <h3>Get In Touch</h3>
         <Formik
            initialValues={initvalues}
            onSubmit={(values) => {
               console.log(values)
            }}
            validationSchema={schema}>
            {({ handleSubmit, errors, touched }) => (
               <>
                  <ContactForm
                     submit={handleSubmit}
                     error={errors}
                     touched={touched}
                     Field={Field}
                  />
               </>
            )}
         </Formik>
      </div>
   )
}

export default Contact
